var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_17258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9402 21.2588H26.8565V20.3026H27.9402C28.7052 20.3026 29.3427 19.6651 29.3427 18.9001V12.2063C29.3427 10.9951 28.3227 9.97508 27.1115 9.97508H20.099C18.8877 9.97508 17.8677 10.9951 17.8677 12.2063V18.9001C17.8677 19.6651 18.5052 20.3026 19.2702 20.3026H20.354V21.2588H19.2702C17.9315 21.2588 16.9115 20.1751 16.9115 18.9001V12.2063C16.9115 10.4213 18.314 9.01883 20.099 9.01883H27.1752C28.9602 9.01883 30.3627 10.4213 30.3627 12.2063V18.9001C30.3627 20.2388 29.279 21.2588 27.9402 21.2588ZM23.6052 7.99883C21.6927 7.99883 20.099 6.40508 20.099 4.49258C20.099 2.58008 21.6927 0.986328 23.6052 0.986328C25.5177 0.986328 27.1115 2.58008 27.1115 4.49258C27.1115 6.40508 25.5815 7.99883 23.6052 7.99883ZM23.6052 2.00633C22.2027 2.00633 21.0552 3.15383 21.0552 4.55633C21.0552 5.95883 22.2027 7.10633 23.6052 7.10633C25.0077 7.10633 26.1552 5.95883 26.1552 4.55633C26.1552 3.15383 25.0077 2.00633 23.6052 2.00633Z",
    fill: "#F5F5F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2627 30.6937C24.6252 30.6937 24.0514 30.3749 23.6689 29.9287C23.2864 30.3749 22.7127 30.6937 22.0752 30.6937C20.9277 30.6937 19.9714 29.7374 19.9714 28.5899V13.0349H20.9277V28.5899C20.9277 29.2274 21.4377 29.7374 22.0752 29.7374C22.7127 29.7374 23.1589 29.1637 23.1589 28.5899V20.8124H24.1152V28.5899C24.1152 29.2274 24.6252 29.7374 25.2627 29.7374C25.9002 29.7374 26.4102 29.2274 26.4102 28.5899V13.0349H27.3664V28.5899C27.3664 29.7374 26.4102 30.6937 25.2627 30.6937Z",
    fill: "#F5F5F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3777 24.0636H0.718994V4.04614H18.6965V5.00239H1.67524V23.1074H18.3777V24.0636Z",
    fill: "#F5F5F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2539 12.9712H4.28894V13.9274H15.2539V12.9712Z",
    fill: "#F5F5F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2539 16.2224H4.28894V17.1787H15.2539V16.2224Z",
    fill: "#F5F5F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2539 19.5374H4.28894V20.4936H15.2539V19.5374Z",
    fill: "#F5F5F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_17258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.6,
    height: 30.6,
    fill: "white",
    transform: "translate(0.208984 0.540039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoard);
export default __webpack_public_path__ + "static/media/board.45a256c6fff8ba89f303b095194c2ee2.svg";
export { ForwardRef as ReactComponent };